<template>
	<TransitionRoot appear :show="isOpen" as="template">
		<Dialog as="div" @close="closeModal">
			<div class="fixed inset-0 z-10 overflow-y-auto">
				<div class="min-h-screen px-4 text-center">
					<TransitionChild
						as="template"
						enter="duration-300 ease-out"
						enter-from="opacity-0"
						enter-to="opacity-100"
						leave="duration-200 ease-in"
						leave-from="opacity-100"
						leave-to="opacity-0"
					>
						<DialogOverlay class="fixed inset-0" />
					</TransitionChild>

					<span class="inline-block h-screen align-middle" aria-hidden="true">
						&#8203;
					</span>

					<TransitionChild
						as="template"
						enter="duration-300 ease-out"
						enter-from="opacity-0 scale-95"
						enter-to="opacity-100 scale-100"
						leave="duration-200 ease-in"
						leave-from="opacity-100 scale-100"
						leave-to="opacity-0 scale-95"
					>
						<div
							class="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-gray-50 bg-white p-6 text-left align-middle shadow-xl transition-all"
						>
							<!-- <DialogTitle
                    as="h3"
                    class="text-lg font-medium leading-6 text-gray-900"
                  >
                    Payment successful
                  </DialogTitle> -->
							<!-- <div class="mt-2"> -->
							<!-- <div class="text-sm text-gray-500">
                      Your payment has been successfully submitted. We’ve sent you
                      an email with all of the details of your order.
                      
                    </div> -->
							test
							<img :src="picUrl" class="h-full w-full object-cover" />

							<!-- </div> -->

							<div class="mt-4 mr-0 text-right">
								<button
									type="button"
									class="justify-right inline-flex rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
									@click="closeModal"
								>
									Schließen
								</button>
							</div>
						</div>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";
import { ref } from "vue";
import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";

export default {
	mixins: [InteractsWithQueryBuilder],
	components: {
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
	},
	props: {
		isOpen: Boolean,
	},

	setup() {
		const isOpen = ref(false);
		const picUrl = ref("");

		return {
			isOpen,
			picUrl,
			closeModal() {
				isOpen.value = false;
			},
			openModal(image) {
				isOpen.value = true;
				console.log("test");
				console.log(image.url);
				if (image.url != "") {
					picUrl.value = image.url;
				}
				console.log(picUrl);
			},
		};
	},
	data() {
		return {
			// Calculate milliseconds in a year
		};
	},
	methods: {
		/**
		 *
		 */
		changeImageWhen: function (imageArray, state) {
			if (state == "over") {
				this.hovered = true;
				return imageArray.url;
			}
			if (state == "down") {
				this.hovered = false;
				return imageArray.urlPreview;
			}
		},
	},
};
</script>
